<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("users.title") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="userFilter"
          :options="userOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:userFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label>REMS</label>
        <b-form-input
          :value="remsFilter"
          type="number"
          min="0"
          class="w-100"
          :placeholder="$t('id') || 'ID'"
          @input="(v) => $emit('update:remsFilter', v !== '' && v != null ? Number(v) : null)"
        />
      </b-col>
    </b-row>

    <!-- Row: REMS / SIRH (IDs) -->
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>SIRH</label>
        <b-form-input
          :value="sirhFilter"
          type="number"
          min="0"
          class="w-100"
          :placeholder="$t('id') || 'ID'"
          @input="(v) => $emit('update:sirhFilter', v !== '' && v != null ? Number(v) : null)"
        />
      </b-col>
      <!-- country -->
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("unit.entity") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="countryFilter"
          :options="countryOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:countryFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("municipality.title", 1)}}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="municipalityFilter"
          :options="municipalityOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:municipalityFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("risk.filters.status_form") }}</label>
        <v-select
          :value="statusFilter"
          :options="statusOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:statusFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>

    <b-row aling-v="center" class="d-flex aling-items-center">

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("risk.status_assigned") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="responsableFilter"
          :options="userOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:responsableFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("risk.status_in_review") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="assignedFilter"
          :options="userOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:assignedFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-0">
        <label class="text-capitalize">{{ $t("log_microservice.start_date") }}</label>
        <div class="input-group">
          <flat-pickr
            :value="startDate"
            class="form-control"
            @input="(val) => dateStartClick(val)"
            :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            :style="dateStartRequired ? 'border: solid red 1px' : ''"
          />
          <div class="input-group-append">
            <button @click="handleClearDates()" class="btn btn-outline-primary" type="button">
              x
            </button>
          </div>
        </div>
        <div class="errorText" v-show="dateStartRequired">
          {{ $t("log_microservice.The_start_date_value_is_required_for_filter_by_date") }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("log_microservice.end_date") }}</label>
        <div class="input-group">
          <flat-pickr
            :value="endDate"
            class="form-control"
            @input="(val) => dateEndClick(val)"
            :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            :style="dateEndRequired ? 'border: solid red 1px' : ''"
          />
          <div class="input-group-append">
            <button @click="handleClearDates()" class="btn btn-outline-primary" type="button">
              x
            </button>
          </div>
        </div>
        <div class="errorText" v-show="dateEndRequired">
          {{ $t("log_microservice.The_end_date_value_is_required_to_filter_by_date") }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormCheckbox, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from 'vue-flatpickr-component';
import { reduce } from "lodash";
import defaultLayout from "@/config/defaultLayout";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    BFormInput,
    vSelect,
    flatPickr,
  },
  props: {
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitFilter: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
    userFilter: {
      type: Array,
      default: () => [],
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    countryFilter: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
    municipalityFilter: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    statusFilter: {
      type: Array,
      default: () => [],
    },
    responsableFilter: {
      type: Array,
      default: () => [],
    },
    assignedFilter: {
      type: Array,
      default: () => [],
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    remsFilter: {
      type: [Number, String, null],
      default: null,
    },
    sirhFilter: {
      type: [Number, String, null],
      default: null,
    },
  },
  data() {
    return {
      dateStartRequired: false,
      dateEndRequired: false,
      dateStartComponent: null,
      dateEndComponent: null,
    };
  },
  methods: {
    verification() {
      const start = this.dateStartComponent ?? this.startDate;
      const end = this.dateEndComponent ?? this.endDate;

      this.dateStartRequired = !start;
      this.dateEndRequired = !end;

      if (start && end) {
        this.$emit('update:startDate', this.dateStartComponent || this.startDate);
        this.$emit('update:endDate', this.dateEndComponent || this.endDate);
      }
    },

    handleClearDates() {
      this.$emit('update:startDate', null);
      this.dateStartRequired = false;
      this.dateStartComponent = null;
      this.$emit('update:endDate', null);
      this.dateEndRequired = false;
      this.dateEndComponent = null;
    },

    dateStartClick(val) {
      if (val !== "") {
        this.dateStartComponent = val;
        this.verification();
      }
    },

    dateEndClick(val) {
      if (val !== "") {
        this.dateEndComponent = val;
        this.verification();
      }
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.errorText {
  color: red;
  font-size: 12px;
}
</style>
